import { render } from "./CartPage.vue?vue&type=template&id=3cea288c&scoped=true"
import script from "./CartPage.vue?vue&type=script&lang=js"
export * from "./CartPage.vue?vue&type=script&lang=js"

import "./CartPage.vue?vue&type=style&index=0&id=3cea288c&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/colordemy-customers/colordemy-customers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cea288c"]])

export default __exports__